import React from "react";
import { useEffect } from "react";
import img1 from "./images/thandaimenu.webp";
import img2 from "./images/gakkadmenu.webp";
import img3 from "./images/baflemenu.webp";
import img4 from "./images/allomenu.webp";
import img5 from "./images/dallmenu.webp";
import img6 from "./images/kadimenu.webp";
import img7 from "./images/ricemenu.webp";
import img8 from "./images/acharmenu.webp";
import img9 from "./images/pappdmenu.webp";
import img10 from "./images/ghevarmenu.webp";

const MenuCards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const menuItems = [
    {
      name: "Thandai",
      image: img1,
    },
    {
      name: "Gakkad",
      image: img2,
    },
    {
      name: "Bafle",
      image: img3,
    },
    {
      name: "Aloo Baigan Bharta",
      image: img4,
    },
    {
      name: "Daal",
      image: img5,
    },
    {
      name: "Rajasthani Kadi",
      image: img6,
    },
    {
      name: "Rice",
      image: img7,
    },
    {
      name: "Achar & Chutney",
      image: img8,
    },
    {
      name: "Papad & Salad",
      image: img9,
    },
  ];

  const ghevarItem = {
    name: "Ghevar",
    subtitle: "( Single Serving )",
    image: img10,
  };

  return (
    <div className="menu-cards-container">
      {/* Grid of Regular Cards */}
      <div className="menu-grid">
        {menuItems.map((item, index) => (
          <div key={index} className="menu-card">
            <div className="menu-card-content">
              <div className="menu-card-text">{item.name}</div>
              <div className="menu-card-image">
                <img src={item.image} alt={item.name} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Special Ghevar Card */}
      <div className="ghevar-card">
        <div className="ghevar-content">
          <div className="ghevar-text">
            <span>{ghevarItem.name}</span>
            <span className="subtitle">{ghevarItem.subtitle}</span>
          </div>
          <div className="ghevar-image">
            <img src={ghevarItem.image} alt={ghevarItem.name} />
          </div>
        </div>
      </div>

      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* Performance optimizations */
        * {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .menu-cards-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px;
          overflow-x: hidden;
          position: relative;
          background-color: #fff5e6;
          will-change: auto;
        }

        .menu-cards-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: url("https://t3.ftcdn.net/jpg/12/42/59/04/360_F_1242590497_fcNb4fNbKtPn0TmjGRdnqcLiHshGRSs5.jpg");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          opacity: 0.15;
          z-index: 0;
          pointer-events: none;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .menu-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-bottom: 20px;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .menu-card {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
          cursor: pointer;
          max-width: 100%;
          height: 140px;
          position: relative;
          z-index: 1;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          will-change: transform;
        }

        .menu-card:hover {
          transform: translateY(-5px) translateZ(0);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }

        .menu-card-content {
          display: flex;
          align-items: stretch;
          padding: 0;
          height: 100%;
        }

        .menu-card-text {
          flex: 1;
          padding: 20px 15px;
          background: linear-gradient(135deg, #e8f4ff 0%, #ffffff 100%);
          font-weight: 700;
          font-size: 18px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1.2;
        }

        .menu-card-image {
          flex: 1;
          height: 100%;
          overflow: hidden;
        }

        .menu-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        }

        .ghevar-card {
          background: linear-gradient(
            90deg,
            #f9ca24 0%,
            #f9ca24 50%,
            transparent 50%
          );
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
          cursor: pointer;
          margin-top: 20px;
          height: 160px;
          width: 100%;
          position: relative;
          z-index: 1;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          will-change: transform;
        }

        .ghevar-card:hover {
          transform: translateY(-5px) translateZ(0);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }

        .ghevar-content {
          display: flex;
          align-items: stretch;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          height: 100%;
        }

        .ghevar-text {
          flex: 1;
          padding: 30px;
          background: #f9ca24;
          font-weight: 700;
          font-size: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .ghevar-text .subtitle {
          font-weight: 400;
          font-size: 20px;
          margin-left: 10px;
        }

        .ghevar-image {
          flex: 1;
          height: 100%;
          overflow: hidden;
          background: #8b2635;
        }

        .ghevar-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        }

        @media (max-width: 1024px) {
          .menu-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .menu-card {
            height: 120px;
          }

          .menu-card-text {
            font-size: 15px;
            padding: 10px 8px;
            font-weight: 700;
          }

          .ghevar-card {
            height: 140px;
          }

          .ghevar-text {
            font-size: 20px;
            padding: 20px 15px;
          }

          .ghevar-text .subtitle {
            font-size: 16px;
          }
        }

        @media (max-width: 640px) {
          .menu-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .menu-grid {
            gap: 15px;
            grid-template-columns: 1fr;
          }

          .menu-card {
            height: 120px;
          }

          .menu-card-content {
            flex-direction: row;
          }

          .menu-card-text {
            flex: 1;
            padding: 15px 12px;
            font-size: 15px;
            font-weight: 700;
          }

          .menu-card-image {
            flex: 1;
            height: 100%;
          }

          .ghevar-card {
            height: 140px;
          }

          .ghevar-content {
            flex-direction: row;
          }

          .ghevar-text {
            flex: 1;
            padding: 20px 15px;
            font-size: 20px;
          }

          .ghevar-text .subtitle {
            font-size: 15px;
            display: block;
            margin-left: 0;
            margin-top: 5px;
          }

          .ghevar-image {
            flex: 1;
            height: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default MenuCards;
